/**
 * This is a specific helper that is needed to determine the exact percentage value for an element that is positioned as follows pattern (similar to positioning as in background-position CSS property):
 *
 *    element {
 *     left: [x];
 *     top: [y];
 *     transform: translate(calc([x] * -1), calc([y] * -1));
 *   }
 */

const getSuitableTransformPosition = ({
  elementBounds,
  areaBounds,
  distance,
  axisProp,
  startPosition,
}) => {
  if (distance <= 0) {
    return 0;
  }

  const minPosition = startPosition || 0;
  const maxPosition = 100;

  // Direct mathematical calculation instead of iterative approach
  // For background-position-like behavior: diff = percentage * (area - element) / 100
  // Solving for percentage: percentage = (distance * 100) / (area - element)

  const areaDimension = areaBounds[axisProp];
  const elementDimension = elementBounds[axisProp];
  const availableSpace = areaDimension - elementDimension;

  if (availableSpace <= 0) {
    return minPosition;
  }

  // Calculate the exact percentage that gives us the target distance
  const calculatedPosition = (distance * 100) / availableSpace;

  // Clamp to the valid range
  return Math.max(minPosition, Math.min(maxPosition, calculatedPosition));
};

export default getSuitableTransformPosition;
